module.exports = __webpack_public_path__ + "static/media/map.6d362829.png";